export const SAVE_ALL_MAINTENANCE_STATUS = 'SAVE_ALL_MAINTENANCE_STATUS'
